document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.single-page-scroller');
  if (!container) return;

  const sliderTrack = container.querySelector('.single-page-scroller__slider-track');
  const slides = container.querySelectorAll('.single-page-scroller__slide');
  // return early if there's only 1 or less slides because we don't need to slide
  if (slides.length < 2) return;


  //  Always showing 1 slide at a time 
  const visibleSlides = 1;
  let slideWidth = container.querySelector('.single-page-scroller__slider').offsetWidth;

  function updateSlidePosition() {
    sliderTrack.style.transform = 'translateX(-' + currentIndex * slideWidth + 'px)';
  }

  //  Start at index 1 (after the cloned last slide) 
  let currentIndex = 1;
  updateSlidePosition();

  function nextSlide() {
    currentIndex++;
    sliderTrack.style.transition = 'transform 0.5s ease-in-out';
    updateSlidePosition();

    //  If we've reached the cloned first slide at the end 
    if (currentIndex >= slides.length - 1) {
      setTimeout(() => {
        sliderTrack.style.transition = 'none';
        currentIndex = 1;
        updateSlidePosition();
        void sliderTrack.offsetWidth; // Force reflow
        sliderTrack.style.transition = 'transform 0.5s ease-in-out';
      }, 500);
    }
  }

  function prevSlide() {
    currentIndex--;
    sliderTrack.style.transition = 'transform 0.5s ease-in-out';
    updateSlidePosition();

    //  If we've reached the cloned last slide at the beginning 
    if (currentIndex < 1) {
      setTimeout(() => {
        sliderTrack.style.transition = 'none';
        currentIndex = slides.length - 2;
        updateSlidePosition();
        void sliderTrack.offsetWidth; // Force reflow
        sliderTrack.style.transition = 'transform 0.5s ease-in-out';
      }, 500);
    }
  }

  const leftArrow = container.querySelector('.single-page-scroller__arrow--left');
  const rightArrow = container.querySelector('.single-page-scroller__arrow--right');

  if (leftArrow) leftArrow.addEventListener('click', prevSlide);
  if (rightArrow) rightArrow.addEventListener('click', nextSlide);

  //  Recalculate on window resize 
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    //  debounce resize check 
    resizeTimer = setTimeout(() => {
      slideWidth = container.querySelector('.single-page-scroller__slider').offsetWidth;
      sliderTrack.style.transition = 'none';
      updateSlidePosition();
      void sliderTrack.offsetWidth;
      sliderTrack.style.transition = 'transform 0.5s ease-in-out';
    }, 250);
  });
})